export default {
  data() {
    return {};
  },
  computed: {},
  methods: {
    checkDuplicate(index, value, type) {
      if (this.formBuilder.approval_users) {
        let otherUsers = this.formBuilder.approval_users.find(
          (user, i) => i != index && user[type] == value
        );
        return otherUsers ? true : false;
      }
      return false;
    },
    getUserTypeContacts(type) {
      return this.allContacts.filter((e) => {
        if (e?.contact_types) {
          return e.contact_types.find(
            (el) => el?.contact_type?._id == type || el?.contact_type == type
          )
            ? true
            : false;
        }
      });
    },
    checkIsIndividualEntityUserType(type) {
      let isIndividualEntity = this.getAllContactTypes?.find(
        (ctype) => ctype._id == type && ctype.entity_type == "INDIVIDUAL"
      );
      return isIndividualEntity ? true : false;
    },
    checkIsBusinessUserType(type) {
      let isBusiness = this.getAllContactTypes?.find(
        (ctype) => ctype._id == type && ctype.entity_type == "BUSINESS"
      );
      return isBusiness ? true : false;
    },
    getCompanyUsersByType(type) {
      return this.company_users.filter((e) => {
        if (e?.rolesList) {
          return e.rolesList.find((el) => el?.userType?._id == type)
            ? true
            : false;
        } else {
          return e.roles.find((el) => el?.userType_id == type) ? true : false;
        }
      });
    },
    updateApplicationUserType(user) {
      this.$set(user, "preferred_application_users", []);
    },
    updateCompanyUsers(value, user) {
      this.$set(user, "preferred_company_users", []);
      if (value) {
        let users = this.getCompanyUsersByType(value);
        if (users && users.length == 1) {
          user.preferred_company_users = [...users.map((e) => e._id)];
        }
      }
    },
    updateUserType(index) {
      if (
        this.formBuilder?.approval_users?.length &&
        this.formBuilder.approval_users?.[index] &&
        this.formBuilder.approval_users[index]?.user_type &&
        ["COMPANY", "APPLICATION"].includes(
          this.formBuilder.approval_users[index].user_type
        ) &&
        this.formBuilder.approval_users[index].approval_linked_field
      ) {
        this.formBuilder.approval_users[index].approval_linked_field = "";
      }
    },
  },
};
